// extracted by mini-css-extract-plugin
export default {"custom-table":"Table_custom-table__TSV6R","date-time":"Table_date-time__F0QKQ","hidden-text":"Table_hidden-text__tmfsV","header-background":"Table_header-background__jgHGc"};